import React from 'react'
import { connect } from 'react-redux'

import MaintenanceInfoEdit from './MaintenanceInfoEdit'

const MaintenanceInfo = ({ maintenanceInfo, adminMode }) => (
    <div>
        <h1>Maintenance infos</h1>
        {maintenanceInfo ?
            !adminMode && <p dangerouslySetInnerHTML={{ __html: maintenanceInfo.text }}></p> :
            <p>No maintenance infos right now...</p>
        }
        {adminMode && <MaintenanceInfoEdit />}

    </div>
)

function mapStateToProps(state) {
    return {
        adminMode: state.user.isGlobalAdmin,
        maintenanceInfo: state.config.maintenanceInfo
    }
}

export default connect(mapStateToProps)(MaintenanceInfo)


// WEBPACK FOOTER //
// ./containers/Maintenance.jsx